import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './MapContact.css';

const MapContact = () => {
  return (
    <>
        <div className="map-section mt-md-5 mb-5">
        <div className="container">
            <div className="row">
                <div className="col-md-12 mt-5">
                    <div className="d-flex justify-content-center">
                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/map.png" alt="" loading="lazy"  />
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* <!-- .............................details-section.................................... --> */}

    <div className="details-section mt-5 pt-md-5">
        <div className="container px-xxl-5 px-lg-4 mt-md-3">
            <div className="row mb-md-5 px-xxl-3">
                <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center padding mb-2">
                    <div className="box1 office">
                        <div className="d-flex flex-column pb-md-4 mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5">
                            <h2 className="headings text-center first-section position-relative zindex mt-md-4 mt-2">Our Office</h2>
                            <p className="text-center">1210-1211, Regal Tower,<br /> Business Bay, Dubai UAE</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center padding mb-2">
                    <div className="box1 phone">
                        <div className="d-flex flex-column pb-md-4  mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5">
                            <h2 className="headings text-center second-section position-relative zindex mt-md-4 mt-2">Phone</h2>
                            <p className="text-center mt-md-3">UAE - +971 4770 7355</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center mt-md-4 mt-3 padding">
                    <div className="box1 email">
                        <div className="d-flex flex-column mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5 pb-4">
                            <h2 className="headings text-center third-section position-relative zindex mt-md-4 mt-2">Email</h2>
                            <p className="text-center mt-md-3">Info@blueberry-travel.com</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3 col-6 mt-md-5 mb-lg-5 d-flex justify-content-center mt-md-4 mt-3 padding">
                    <div className="box1 website">
                        <div className="d-flex flex-column mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5 pb-4">
                            <h2 className="headings text-center fourth-section position-relative zindex mt-md-4 mt-2">Website</h2>
                            <p className="text-center mt-md-3">www.blueberry-travel.com</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    </>
  )
}

export default MapContact